import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1
        style={{
          fontFamily: 'var(--font-heading-active)',
          fontSize: '2rem',
          fontWeight: 700,
          color: 'var(--text)',
          marginBottom: '0.5rem',
        }}
      >
        404 · Not found
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
        The page you&rsquo;re looking for doesn&rsquo;t exist.
      </p>
      <Link to="/" style={{ color: 'var(--brand-primary)' }}>
        Go home
      </Link>
    </main>
  );
}
